<template>
    <div class="wrapper">
    <div class="search_wrap">
      <el-form :model="queryParams" ref="form" :inline="true" size="mini">
        <el-form-item label="设备名称">
          <el-input
            @keyup.enter.native="searchQuery"
            v-model="queryParams.deviceName"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="设备号">
          <el-input
            @keyup.enter.native="searchQuery"
            v-model="queryParams.deviceNo"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="点位地址">
          <el-input
            @keyup.enter.native="searchQuery"
            v-model="queryParams.address"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="设备状态">
          <el-select
            v-model="queryParams.deviceStatus"
            placeholder="请选择状态"
          >
            <el-option
              :label="item.value"
              :value="item.id"
              v-for="(item, key) in statusOptions"
              :key="key"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="searchQuery">查询</el-button>
          <el-button type="default" @click="searchReset">重置</el-button>
          <el-button size="mini" type="primary" @click="handleAdd()"
            >新增</el-button
          >
        </el-form-item>
      </el-form>
    </div>
      <el-table
      :data="list"
      ref="multipleTable"
      stripe
      style="width: 100%">
      <el-table-column
        prop="deviceName"
        label="设备名称"
        width="180">
        <template slot-scope="scope">
           {{ scope.row.deviceName}}
        </template>
      </el-table-column>
      <el-table-column
        prop="deviceNo"
        label="设备号"
        width="180">
        <template slot-scope="scope">
           {{ scope.row.deviceNo}}
        </template>
      </el-table-column>
      <el-table-column
        prop="address"
        label="点位地址"
        width="380">
        <template slot-scope="scope">
           {{ scope.row.address}}
        </template>
      </el-table-column>
      <el-table-column
        prop="phone"
        label="设备剩余数量"
        width="180">
        <template slot-scope="scope">
           {{ scope.row.remainNum}}
        </template>
      </el-table-column>
      <el-table-column
        prop="isPrint"
        label="今日交投量"
        width="180">
        <template slot-scope="scope">
            {{ scope.row.todayTradeNums}}
        </template>
      </el-table-column>
      <el-table-column
        prop="deviceStatus"
        label="设备状态"
        width="180">
        <template slot-scope="scope">
           {{ setStatus(scope.row.deviceStatus)}}
        </template>
      </el-table-column>
      <el-table-column
        prop="latitude"
        label="维度"
        width="180">
        <template slot-scope="scope">
           {{ scope.row.latitude}}
        </template>
      </el-table-column>
      <el-table-column
        prop="longitude"
        label="精度"
        width="180">
        <template slot-scope="scope">
           {{ scope.row.longitude}}
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        label="操作"
        width="180">
        <template slot-scope="scope">
            <el-button @click="edit(scope.row)" size="mini">编辑</el-button>
            <el-popconfirm
            style="margin-left: 10px"
            title="确定删除吗？"
            @confirm="handleDelete(slotData.data.row.id)"
            >
          <!-- <template #reference>
            <el-button type="danger" size="mini">删除</el-button>
          </template> -->
        </el-popconfirm>
        </template>
      </el-table-column>
      </el-table>
      <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="pageNo"
      :page-sizes="pageSizes"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next"
      :total="total">
    </el-pagination>
    <el-dialog
      :title="formText"
      :visible.sync="dialogFormVisible"
      @close="close"
    >
      <el-form
        :model="formData"
        :rules="rules"
        ref="formData"
        label-width="120px"
        class="demo-formData"
      >
        <el-form-item label="设备名称" prop="deviceName">
          <el-input v-model="formData.deviceName"></el-input>
        </el-form-item>
        <el-form-item label="设备号" prop="deviceNo">
          <el-input v-model="formData.deviceNo"></el-input>
        </el-form-item>
        <el-form-item label="点位地址" prop="address">
          <el-input v-model="formData.address"></el-input>
        </el-form-item>
        <el-form-item label="设备剩余数量" prop="remainNum">
          <el-input v-model="formData.remainNum"></el-input>
        </el-form-item>
        <el-form-item label="设备状态" prop="deviceStatus">
          <el-select
            v-model="formData.deviceStatus"
            placeholder="请选择状态"
          >
            <el-option
              :label="item.value"
              :value="item.id"
              v-for="(item, key) in statusOptions"
              :key="key"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="维度" prop="latitude">
          <el-input v-model="formData.latitude"></el-input>
        </el-form-item>
        <el-form-item label="精度" prop="longitude">
          <el-input v-model="formData.longitude"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="submit('formData')">提交</el-button>
          <el-button @click="resetForm('formData')">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    </div>
  </template>
  
  <script>
  import {getTraceCodeList,editTraceCode,addTraceCode} from '@/api/traceabilityCode';

  export default {    
   // components: { 'el-table': ElTable },  
    data() {
      return {
       list:[],
       total: 0,
       pageSizes: [15, 20, 30, 40, 100, 200],
       pageSize: 15,
       pageNo: 1,
       statusOptions: [{id: 1, value: '未启用'}, {id: 2, value: '启用'}],
       queryParams: {
        deviceName: undefined,
        deviceNo: undefined,
        address: undefined,
        deviceStatus: undefined,
       },
       formText: '添加',
       dialogFormVisible: false,
       formData: {
        deviceName: '',
        deviceNo: '',
        address: '',
        remainNum: undefined,
        todayTradeNums: undefined,
        deviceStatus: undefined,
        latitude: undefined,
        longitude: undefined, 
       },
       rules: {
       deviceName: [
          { required: true, message: "请输入设备名称", trigger: "blur" },
        ],
        deviceNo: [
          { required: true, message: "请输入设备号", trigger: "blur" },
        ],
        address: [
          { required: true, message: "请输入点位地址", trigger: "blur" },
        ],
        remainNum: [
          { required: true, message: "请输入设备剩余量", trigger: "blur" },
        ],
        deviceStatus: [
          { required: true, message: "请输入设备剩余量", trigger: "blur" },
        ],
        latitude: [
          { required: true, message: "请输入设备剩余量", trigger: "blur" },
        ],
        longitude: [
          { required: true, message: "请输入设备剩余量", trigger: "blur" },
        ],
       },
       isAdd: true
      };
    },
    watch: {},
    computed: {},
    mounted() {
      this.getDataList();
    },
    methods: {
    getDataList() {
        const params = {
        pageNo:this.pageNo,
        pageSize: this.pageSize,
        ...this.queryParams
        }
        getTraceCodeList(params).then((res)=>{
        this.list = res.data.records;
        this.total = res.data.total
        })
    },
    searchQuery(){
        this.getDataList();
    },
    searchReset() { 
        this.queryParams.deviceName= undefined;
        this.queryParams.deviceNo=undefined;
        this.queryParams.address= undefined;
        this.queryParams.deviceStatus= undefined;
    },
    edit(item) {
        this.dialogFormVisible = true;
        this.formData.id = item.id;
        this.formData.deviceName = item.deviceName;
        this.formData.deviceNo = item.deviceNo;
        this.formData.address = item.address;
        this.formData.remainNum = item.remainNum;
        this.formData.todayTradeNums = item.todayTradeNums;
        this.formData.deviceStatus = item.deviceStatus;
        this.formData.latitude = item.latitude;
        this.formData.longitude = item.longitude;
        this.formText = '修改';
    },
    handleDelete() {

    },
    handleAdd() {
        this.dialogFormVisible = true;
        this.formText = '添加';
    },
    close() {
       this.formClear();
       this.dialogFormVisible = false;
    },
    formClear() {
      this.formData.deviceName = "";
      this.formData.deviceNo = "";
      this.formData.address = "";
      this.formData.remainNum = undefined;
      this.formData.todayTradeNums = undefined;
      this.formData.deviceStatus = undefined;
      this.formData.latitude = undefined;
      this.formData.longitude = undefined;
      this.$nextTick(() => {
       this.$refs["formData"].clearValidate();
    })
  },
    resetForm() {
        this.formClear();
    },
    submit(formName){
        this.$refs[formName].validate((valid) => {
            if(valid) {
                if(this.formText === '添加') {
                    addTraceCode(this.formData).then((res)=>{
                    if (res.code == 200) {
                        this.$message.success('提交成功');
                        this.formClear();
                        this.getDataList();
                        } else {
                        this.$message.error(res.msg);
                        } 
                        this.dialogFormVisible = false;  
                    })
            } else {
                editTraceCode(this.formData).then((res)=>{
                if (res.code == 200) {
                    this.$message.success('提交成功');
                    this.formClear();
                    this.getDataList();
                    } else {
                    this.$message.error(res.msg);
                }
                this.dialogFormVisible = false;   
                })
           }
        }
        })
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageNo = 1;
      this.getDataList();
    },
    // 显示第几页
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getDataList();
    },
    setStatus(val) {
        const item = this.statusOptions.find((item)=> item.id === val);
        if(item)  return item.value
        return '';  
    },
      
    },
    
  };
  </script>
  <style lang="scss" scoped>
  .wrapper {
    padding: 20px;
    .el-pagination {
        text-align: right;
    }
    .el-table .el-table__cell {
        text-align: center;
    }
    .el-select {
        width: 100%;
    }
  }
  </style>
  